// extracted by mini-css-extract-plugin
export default {"surcharge":"G11be7a","valueBackground":"G320421"};